






































































import { BASE_URL } from "@/plugins/axios";
import { UserInterface } from "@/utils/UserInterface";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import SigPanel from './SigPanel.vue'
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: { SigPanel}
})
export default class SigTester extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	mounted(){
    this.UI__ = new UserInterface(this);


		// setInterval(()=>{

		// 	// console.log(this.$refs.jatajata[0], this.$refs.jatajata);
		// 	var isIt = this.isVisible( this.$refs.jatajata );
		// 	console.log("am i visible ? ", isIt);
		// }, 2000);

	}

	private isVisible(element:any): boolean {
			return element && ( 
					element.clientHeight !== 0 ||
					element.getClientRects().length !== 0 ||
					getComputedStyle(element).display !== 'none'
			);
	}



	/* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  // @Prop()
  // public cfg: any;

  /* PRIVATE VARIABLES, __ POSTFIXED */
	private UI__: UserInterface;

  /* VUE DATA */
  public signature: string = null;
	public disabled: boolean = false;
	public toggle: boolean = true;

  /* VUE WATCH */
  // @Watch("value")
  // onValueChanged(newVal: any, oldVal: any) {}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
	public DisableThem():void{
		this.disabled = !this.disabled;
	}



	public ToggleDisplay():void{
		this.toggle = !this.toggle;
	}



	public LoadSignature():void{

		console.log("loading signature");

		this.UI__.TurnBlockerOn();

    this.axios.post(BASE_URL + "?action=signa-test-load", {})
		.then((resp) => {
      console.log(resp.data);

      if (!resp.data.Ok) {
        alert("erreur: " + resp.data.Msg);
        return;
      }

			this.signature = resp.data.Signa;

    }).finally(()=>{
			this.UI__.TurnBlockerOff();
		});
	}


	public SaveSignature():void
	{

		/* 
		GET THE TEST DATA FROM SOMEWHERE !
		*/
    console.log("saving test-data");

    this.axios
      .post(BASE_URL + "?action=signa-test-save", {
        Signa: this.signature,
      })
      .then((resp) => {
        if (!resp.data.Ok) {
          alert(resp.data.Msg);
          return;
        }

        console.log("Signature saved!");
      });

	}
}
